import BaseRequest from './BaseRequest';

const schema = 'order';
/**
 * key base on host:port
 */
export default class OrderRequest extends BaseRequest {
  /**
	 * @description Create order <br/>Order trade type; <br/>-- 0. Buy, 1. Sell<br/>Order type; <br/>-- 0. Limit, 1. Market, 2. StopLimit<br/>Order status; <br/>-- 0. Stopping, 1. Pending, 2. Executed, 3. Canceled, 4. Executing, 5. Removed
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @param {number} params.price
	 * @param {number} params.quantity
	 * @param {number} params.stop_price
	 * @param {number} params.trade_type
	 * @param {number} params.type
	 * @param {number} params.user_id
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  createOrder(params) {
    const url = `${schema}/`;
    return this.post(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {number} params.uid
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchAllOrders(params) {
    const url = `${schema}/all`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {number} params.order_id
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  cancelOrder(params) {
    const url = `${schema}/cancel`;
    return this.post(url, params, false);
  }

  /**
	 * @param {Object} params
	 * @param {number} params.uid
	 * @param {number} params.pos
	 * @param {number} params.count
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchOpenOrders(params) {
    const url = `${schema}/open-orders`;
    return this.get(url, params);
  }

  /**
	 * @description Create order <br/>Order trade type; <br/>-- 0. Buy, 1. Sell<br/>Order type; <br/>-- 0. Limit, 1. Market, 2. StopLimit<br/>Order status; <br/>-- 0. Stopping, 1. Pending, 2. Executed, 3. Canceled, 4. Executing, 5. Removed
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @param {number} params.order_type
	 * @param {number} params.trade_type
	 * @param {number} params.status
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchOrders(params) {
    const url = `${schema}/range-orders`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {number} params.uid
	 * @param {number} params.pos
	 * @param {number} params.count
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchOrderPaginate(params) {
    const url = `${schema}/paginate`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.order_id
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchSingle(params) {
    const url = `${schema}/single`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {number} params.uid
	 * @param {number} params.pos
	 * @param {number} params.count
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchOpenOrderPaginate(params) {
    const url = `${schema}/open-orders-paginate`;
    return this.get(url, params);
  }

  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  cancelAllOrder() {
    const url = `${schema}/cancel-all`;
    return this.post(url);
  }
}
